module.exports = __webpack_public_path__ + "img/buymeacoffee.7bec2394.png";